import React from 'react';
import { cn } from '@/lib/cn';

export interface TextLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
}

/**
 * Link-styled text action (used for tertiary actions like "Discard and exit").
 * Uses a native <button> for accessibility, but looks like text.
 */
export function TextLink({ className, disabled, type = 'button', ...props }: TextLinkProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        'inline-flex items-center gap-1',
        'text-accent hover:text-accent-hover',
        'text-body-2-high',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
        'disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
